const Forms = () => {
	const hubspotForm = document.querySelectorAll(
		'.hbspt-form form.hs-custom-style'
	);

	//Remove hubspot's styling from forms
	if (hubspotForm) {
		hubspotForm.forEach(function (form) {
			form.classList.remove('hs-custom-style');
		});
	}

	// Add source data to Gravity Forms
	const sourceFields = document.querySelectorAll(
		'.gfield input[value="{SourceData}"]'
	);

	if (sourceFields.length > 0) {
		for (let i = 0; i < sourceFields.length; i++) {
			// eslint-disable-next-line no-undef
			let val = Cookies.get('source');
			if (val === null || val === undefined) {
				val = 'No source data detected';
			}
			sourceFields[i].setAttribute('value', val);
		}
	}

	// Add ref data to Gravity For
	const refFields = document.querySelectorAll(
		'.gfield input[value="{referrerURL}"]'
	);

	if (refFields.length > 0) {
		for (let i = 0; i < refFields.length; i++) {
			// eslint-disable-next-line no-undef
			let val = Cookies.get('referrer');
			if (val === null || val === undefined) {
				val = 'No referrer URL detected';
			}
			refFields[i].setAttribute('value', val);
		}
	}
};

export default Forms;
